export const siteName = 'Cergy-Pontoise Airfield'
export const siteOwner = 'Skyports'